import { CategoryOutputModel, FetchingDataModel } from ".";
import { APP_MODULES } from "../constants";
import { RootReducer } from "../store/reducers";
import { AllLabelOutputModel } from "./blog.model";
import { LanguageOutputModel } from "./language.model";

export enum AppNotifications {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export type NotiModel = {
  type: AppNotifications;
  message: string;
};

export type AppNotiModel = {
  id: string;
} & NotiModel;

export type AppRouteModel = {
  sidebarTitle: string;
  appbarTitle: string;
  path: string;
  withSubPaths?: string[];
  icons: { active: any; inactive: any };
  renderComponent: () => any;
  module: APP_MODULES;
};

export type AppRouteMenuModel = {
  title: string;
  path: string;
  icons?: { active: any; inactive: any };
  renderComponent: () => any;
};

export type RootState = ReturnType<typeof RootReducer>;

export declare module AppState {
  export type AllCategoryListState = FetchingDataModel<CategoryOutputModel[]>;
  
  export type AppNotifications = {
    list: AppNotiModel[];
  };

  export type Authentication = {
    loading: boolean;
    data: {
      token: string;
      // refreshToken: string | null;
    } | null;
  };

  export type Me = {
    loading: boolean;
    data: {
      id: string;
      email: string;
      fullName: string;
      userName: string;
      // phoneNumber: string | null;
      // gender: UserGender | null;
      // avatar: string | null;

      modules: APP_MODULES[];
    } | null;
  };
  
  export type AllLanguageListState = FetchingDataModel<LanguageOutputModel[]>;
  export type AllLabelsState = FetchingDataModel<AllLabelOutputModel[]>;
}
